// Endpoints do módulo Central de IA (aawz_ia_framework — Blueprint /api/v1/ai-framework).
// Sub-paths (/:slug, /:id, /pause, /resume, /migrate-version) são montados inline nos
// arquivos de api/ — contrato spec-002 §2.2 (ui-components.md) define só as duas raízes.
const BASE = '/api/v1/ai-framework'

export const URL_CATALOG = `${BASE}/catalog` // + /:slug (spec-001)
export const URL_INSTANCES = `${BASE}/instances` // + /:id, /:id/pause, /:id/resume, /:id/migrate-version

// spec-003 (Conversar) — contrato ui-components §2.1.
// Seletor de agentes utilizáveis pelo profissional da sessão (RF7.2) e SSE do chat.
export const AGENTS_DISPONIVEIS = `${BASE}/agents-disponiveis`
export const AGENT_CHAT = (idInstance) => `${BASE}/agents/${idInstance}/chat`

// Conversas/mensagens reusam os endpoints EXISTENTES do IA CRM (deltas RF7.6 — o
// backend ganha filtro de `context`, default 'CRM'; o chat do parceiro consome com
// context='AI_FRAMEWORK'). id-scoped (rename/soft-delete) = `${IA_CONVERSATIONS}/${id}`.
const IA_BASE = '/api/v1/intelligence-v2'
export const IA_CONVERSATIONS = `${IA_BASE}/conversations`
export const IA_MESSAGES = (id) => `${IA_BASE}/conversations/${id}/messages`

// spec-004 (Auditoria & Aprovações) — contrato ui-components §2.1. Fila do gestor
// (`pending`), decisões por (id_run, ordem_step), execuções read-only e metering.
// A proposta é o step `approval` de um run — a chave lógica é (id_run, ordem_step).
export const APPROVALS_PENDING = `${BASE}/approvals/pending`
export const APPROVAL_APPROVE = (idRun, ordemStep) =>
  `${BASE}/approvals/${idRun}/steps/${ordemStep}/approve`
export const APPROVAL_REJECT = (idRun, ordemStep) =>
  `${BASE}/approvals/${idRun}/steps/${ordemStep}/reject`
export const RUNS = `${BASE}/runs`
export const RUN_DETAIL = (idRun) => `${BASE}/runs/${idRun}`
export const USAGE = `${BASE}/usage`

// spec-001 project-ia-payment (Saldo de créditos) — contrato `contracts/api.md`.
// Leitura do saldo do profissional autenticado; gestor pode passar `id_profissional`
// para consultar outro profissional do MESMO escritório (de não-gestor o param é
// ignorado pelo backend, nunca vira vazamento). HTTP 200 sempre — status no body.
export const CREDITOS_SALDO = `${BASE}/creditos/saldo`

// spec-002 project-ia-payment (Compra de créditos via Stripe) — contrato `contracts/api.md`.
// Catálogo vigente do backend (nunca hardcoded no cliente), criação da sessão de checkout
// e leitura de UM pagamento pelo id — é este último que a tela de retorno consulta em
// polling. HTTP 200 sempre; o status real vem no body, inclusive em 400/404/502.
export const CREDITOS_PACOTES = `${BASE}/creditos/pacotes`
export const CREDITOS_CHECKOUT = `${BASE}/creditos/checkout`
export const CREDITOS_PAGAMENTO = (idPagamento) => `${BASE}/creditos/pagamentos/${idPagamento}`

// spec-003 project-ia-payment (Log de custos em créditos) — contrato `contracts/api.md §1-2`.
// Duas LEITURAS: o extrato paginado dos lançamentos do período (todas as naturezas, sinal
// vindo do valor) e o agregado dos dois indicadores da tela. Escopadas por profissional —
// `id_profissional` só é aceito de gestor, e de não-gestor o backend o ignora em vez de
// erro que confirmaria a existência do alvo. HTTP 200 sempre; status real no body.
// Nenhuma das duas substitui `${BASE}/usage`, que é gestor-only, agrega o ESCRITÓRIO e
// fala em custo de API — outro número, outra pergunta.
export const CREDITOS_EXTRATO = `${BASE}/creditos/extrato`
export const CREDITOS_RESUMO = `${BASE}/creditos/resumo`

// spec-005 project-ia-payment (Planos recorrentes) — contrato `contracts/api.md §1-§5`.
// O catálogo de planos é GLOBAL (a tabela de preços não tem tenant, justificativa P1 em
// `data-model.md §3`) e as 4 rotas de assinatura resolvem o par (escritório, profissional)
// pela SESSÃO — nenhuma delas aceita id de tenant no cliente.
// ★ Cancelar e reativar são POST com o `id_assinatura` no CORPO, não no path: o id é
// explícito de propósito, para que um clique acidental não mova "a assinatura que estiver
// lá". HTTP 200 sempre; o status real (400/404/409/502) vem no body.
export const CREDITOS_PLANOS = `${BASE}/creditos/planos`
export const CREDITOS_ASSINATURA = `${BASE}/creditos/assinatura`
export const CREDITOS_ASSINATURA_CANCELAR = `${BASE}/creditos/assinatura/cancelar`
export const CREDITOS_ASSINATURA_REATIVAR = `${BASE}/creditos/assinatura/reativar`

// ── spec-009 [US-1]: o aceite dos Termos de Uso da PLATAFORMA (não é do módulo de
// atendimento, que tem termos próprios). Fora de `/creditos/` de propósito: o aceite
// existe antes da contratação e não é um dado da carteira.
// GET devolve { versao_vigente, url_termos, aceito, aceito_em }; POST registra e não lê
// corpo nenhum — quem aceitou sai da SESSÃO, a versão sai do servidor, IP e user-agent
// saem do request.
export const TERMOS_PLATAFORMA = `${BASE}/termos-plataforma`
